import script from "./UiLabelsGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiLabelsGroup.vue?vue&type=script&setup=true&lang=ts"

import "./UiLabelsGroup.vue?vue&type=style&index=0&id=3dbe797c&lang=sass"

const __exports__ = script;

export default __exports__